import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgImplementation = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 135,
	height: 135,
	viewBox: "0 0 135 135",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M46.2441 54.6132L41.3754 48.4374M43.8112 58.4627L35.9539 55.356M43.2036 62.8937L35.1621 64.1519",
			stroke: "#F385FF",
			strokeWidth: 3,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M91.2101 80.712L94.9652 87.4414M94.1308 77.3473L101.224 81.5532M95.3825 73.1414L103.31 73.1414",
			stroke: "#F385FF",
			strokeWidth: 3,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 55.2808,
			y: 55.1133,
			width: 47.1642,
			height: 22.9083,
			rx: 3,
			transform: "rotate(-25.7263 55.2808 55.1133)",
			stroke: "#C9D8FC",
			strokeWidth: 7
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 55.2808,
			y: 55.1133,
			width: 47.1642,
			height: 22.9083,
			rx: 3,
			transform: "rotate(-25.7263 55.2808 55.1133)",
			stroke: "white",
			strokeWidth: 3
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 27.1848,
			y: 80.0039,
			width: 47.1642,
			height: 22.9083,
			transform: "rotate(-25.7263 27.1848 80.0039)",
			stroke: "#63688B",
			strokeWidth: 6
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 27.1848,
			y: 80.0039,
			width: 47.1642,
			height: 22.9083,
			transform: "rotate(-25.7263 27.1848 80.0039)",
			stroke: "#63688B",
			strokeWidth: 3
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_467_6819",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 53,
			y: 57,
			width: 13,
			height: 15,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M65.7248 67.6577L62.0583 57.7422L57.1083 59.9422L53.2583 62.1422L57.6395 71.3635L65.7248 67.6577Z",
				fill: "#D9D9D9"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			mask: "url(#mask0_467_6819)",
			children: [/* @__PURE__ */ _jsx("rect", {
				x: 55.2778,
				y: 55.1172,
				width: 47.1642,
				height: 22.9083,
				rx: 5,
				transform: "rotate(-25.7263 55.2778 55.1172)",
				stroke: "#C9D8FC",
				strokeWidth: 7
			}), /* @__PURE__ */ _jsx("rect", {
				x: 55.2778,
				y: 55.1172,
				width: 47.1642,
				height: 22.9083,
				rx: 5,
				transform: "rotate(-25.7263 55.2778 55.1172)",
				stroke: "white",
				strokeWidth: 3
			})]
		})
	]
});
export default SvgImplementation;
